module.exports = __webpack_public_path__ + "static/img/stockactivity.35423d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stockactivity.png
// module id = LQ9a
// module chunks = 1